import { defineMessages } from '@atlassian/jira-intl';

const messages: {
	next: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	previous: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	next: {
		id: 'pagination.next',
		defaultMessage: 'Next page',
		description: 'Label for the next page button',
	},
	previous: {
		id: 'pagination.previous',
		defaultMessage: 'Previous page',
		description: 'Label for the previous page button',
	},
});
export default messages;
